"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../BaseApi"));
var index_1 = require("../../modules/authorize/index");
var axios_1 = tslib_1.__importDefault(require("axios"));
var GraphApi_1 = require("../GraphApi");
var getBFFUrl = function (operationName) {
    if (GraphApi_1.operationsToBFF.checkoutBFFOperations.includes(operationName)) {
        return index_1.checkoutBffInternalUrl;
    }
    else {
        return index_1.digitalPricingBffInternalUrl;
    }
};
var InternalGraphApi = /** @class */ (function () {
    function InternalGraphApi() {
    }
    InternalGraphApi.doFetchPersistedQuery = function (operationName, internalRequestPayload, variables, timeout, logError) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, headers;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        /* istanbul ignore next */
                        timeout = timeout !== null && timeout !== void 0 ? timeout : 30000;
                        url = getBFFUrl(operationName);
                        headers = this.getHeaders(internalRequestPayload);
                        logError = logError === undefined ? true : logError;
                        return [4 /*yield*/, axios_1.default.request({
                                url: url,
                                method: "POST",
                                data: JSON.stringify({
                                    operationName: operationName,
                                    variables: variables
                                }),
                                timeout: timeout,
                                headers: headers,
                                withCredentials: false
                            }).catch(function (errorData) {
                                return BaseApi_1.default.handleException(errorData, operationName, logError, internalRequestPayload);
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InternalGraphApi.getHeaders = function (internalRequestPayload) {
        var loadTest = internalRequestPayload.loadTest, passport = internalRequestPayload.passport, pageUrl = internalRequestPayload.pageUrl, cookie = internalRequestPayload.cookie;
        return {
            "content-type": "application/json;charset=UTF-8",
            Accept: "application/json",
            "X-LoadTests": loadTest || "",
            "CHEGG-PASSPORT": passport || "",
            cookie: cookie || "",
            "X-CHEGG-PAGE-URL": pageUrl || ""
        };
    };
    return InternalGraphApi;
}());
exports.default = InternalGraphApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/API/InternalGraphApi/index.js
// module id = 3409
// module chunks = 11